// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2uazS","productName":"Table_productName__1rAWa"};